import React, { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import VideoForm from "../../components/common/VideoForm";
import { getVideoById, updateVideo } from "../../services/videoService";

export default function VideoEditPage() {
  const { id } = useParams();
  const nav = useNavigate();
  const [video, setVideo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

 useEffect(() => {
  console.log("useParams id:", id); // should be a number/string like "1"
  (async () => {
    try {
      setLoading(true);
      const data = await getVideoById(id);
      console.log("API data:", data);
      setVideo(data);
    } catch (e) {
      console.error("Error fetching video:", e);
      setError(e.message || "Failed to load video");
    } finally {
      setLoading(false);
    }
  })();
}, [id]);

  const handleSubmit = async (data) => {
    try {
      setSubmitting(true);
      await updateVideo(id, data);
      alert("Video updated successfully.");
      nav("/admin/videos");
    } catch (e) {
      alert(e.message || "Failed to update video");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h4 className="mb-0">Edit Video</h4>
        <Link to="/admin/videos" className="btn btn-outline-secondary">Back to List</Link>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <div className="alert alert-danger">{error}</div>
      ) : (
        <VideoForm mode="edit" initialData={video} onSubmit={handleSubmit} submitting={submitting} />
      )}
    </div>
  );
}
